<template>
  <div>
    <div class="sidebar-item">
      <job-queued></job-queued>
    </div>


    <div class="sidebar-item">
      <div class="agenerate-btn-box" :class="{  }">
        <div
            class="generate-btn px-20"
            @click="applyImage"
            v-bind:class="{ 'disabled': isDone === false || this.loading}"
        >

          {{ 'Continue' | trans }}
          <i v-if="!loading" class="far fa-arrow-right font-size-150"></i>
          <i v-if="loading" class="fa fa-spin btn-loading-animation"></i>
        </div>
      </div>
    </div>
    <div class="sidebar-item">
      <export-btn></export-btn>
    </div>

    <div
         class="sys-container d-flex flex-column align-items-center p-0 m-0">
      <div class="sidebar-item"
           v-bind:class="{ 'bg-secondary text-white': image === this.activeStage.mainJob.apiJob.output[0].uri && activeStage.preview === true}"
           v-if="this.activeStage.mainJob !== null" @click="chooseActiveStage()">
        <div class="h-100 d-flex justify-content-between align-items-center">
          <div class="d-flex h-100 align-items-center px-3 font-size-125 h-100 align-items-center">{{ 'Original' | trans }}:</div>
          <div class="sys-thumb"  v-bind:class="{ 'active': image === this.activeStage.mainJob.apiJob.output[0].uri && activeStage.preview === true}">
            <img :src="getImageFromStorage(this.activeStage.mainJob.apiJob.output[0].uri)" class="sys-img">
          </div>
        </div>
      </div>
    </div>

    <div v-for="sysJob in currentJob.getActiveStageJob().sysJobs"
         class="sys-container d-flex flex-column align-items-center p-0 m-0">
      <div class="sidebar-item" v-for="output in sysJob.apiJob.output"
           v-bind:class="{ 'bg-secondary text-white': image === output.uri && activeStage.preview === true}"
           @click="chooseImage(output.uri)">
        <div class="h-100 d-flex justify-content-between align-items-center">
          <div class="d-flex h-100 align-items-center px-3 font-size-125 h-100 align-items-center">{{ 'Generated' | trans }}:</div>
          <div class="sys-thumb" v-bind:class="{ 'active': image === output.uri && activeStage.preview === true}">
            <img :src="getImageFromStorage(output.uri)" class="sys-img">
          </div>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import UploadBox from "../../Elements/UploadBox.vue";
import CanvasManager from "../../../manager/CanvasManager";
import Prompt from "../../Elements/Prompt.vue";
import JobQueued from "../../Elements/JobQueued.vue";
import {JOB_STATE_PROCESSING} from "../../../const/job.const";
import StageManager from "../../../manager/StageManager";
import ExportBtn from "../../Elements/ExportBtn.vue";
import {EventBus} from "../../../events/event.bus";
import {EVENT_JOB_SELECT_OUTPUT, EVENT_JOB_SYS_SUCCESS} from "../../../events/job.events";
import Base64Manager from "../../../manager/Base64Manager";

export default {
  name: "SelectOutputItem",
  props: {},
  components: {ExportBtn, JobQueued, Prompt, UploadBox},
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {
      item_open: false,
      image: '',
    };
  },
  mounted: function () {
  },
  created: function () {
    EventBus.$on(EVENT_JOB_SYS_SUCCESS, (data) => {
      this.chooseImage(this.activeStage.sysJobs[0].apiJob.output[0].uri);
    });
    EventBus.$on(EVENT_JOB_SELECT_OUTPUT, (data) => {
      this.chooseActiveStage();
    });
  },
  methods: {
    getImageFromStorage(url) {
      return url;
    },
    chooseActiveStage() {
      //this.chooseImage(this.activeStage.mainJob.apiJob.output[0].uri);
      this.image = this.activeStage.mainJob.apiJob.output[0].uri;
      CanvasManager.setPreview(this.activeStage, this.activeStage.mainJob.apiJob.output[0].uri);
      CanvasManager.zoomFitAllObjects(this.activeStage);
      //CanvasManager.restoreCanvas(this.activeStage);
    },
    chooseImage(url) {
      this.activeStage.preview = true;
      this.image = url;
      CanvasManager.setPreview(this.activeStage, url);
      CanvasManager.zoomFitAllObjects(this.activeStage);
    },
    applyImage() {
      if (this.currentJob.state === JOB_STATE_PROCESSING) {
        return;
      }
      StageManager.loadNewStageImage(this.currentJob, this.image);
    }
  },
  computed: {
    isActive() {
      return this.activeStage.sysJobs.length > 0;
    },
    isDone() {
      return this.activeStage.preview === true && this.image !== '';
    },
    isDoneApply() {
      return false;
    }
  },
};
</script>
<style lang="scss" scoped>
.next-btn {
  cursor: pointer;

  color: white;
  border-radius: 4px;
  background: #1266F1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 20px;
  gap: 20px;
  font-size: 17.5px;

  border: none;

  &.disabled {
    cursor: not-allowed;
  }
}


.gap-10px {
  gap: 10px;
}

.gap-20px {
  gap: 20px;
}

.gap-30px {
  gap: 30px;
}

.gap-40px {
  gap: 40px;
}

.sys-container {
  height: 100%;
  display: flex;
  gap: 0px;

}

.sys-thumb {
  background: #1E1E1E;

  &.active {
    background: #1266F1 !important;
  }

  padding: 5px;
  border-radius: 4px;
  height: 110px;

  img {
    height: 100px;
  }
}

.bottom-bar-item {
  display: flex;
  align-items: center;
  gap: 10px;
  border-right: 1px solid #595959;
  height: 100%;
  padding: 0 20px;
}

.bottom-bar-item-none {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 0;
  height: 100%;
  padding: 0 20px;
}

.bottom-bar-item-left {
  display: flex;
  align-items: center;
  gap: 10px;
  border-left: 1px solid #595959;
  height: 100%;
  padding: 0 20px;
}

.bottom-bar {
  justify-content: space-between;
  min-height: 105px;
  height: 105px;
  background: #272727;
  gap: 20px;
  padding: 0;
  display: flex;
  align-items: center;
  border-top: 1px solid #595959;
}
</style>
